import { useSearchParams, useRouter, usePathname } from "next/navigation";

export const useQueryParams = () => {
  const searchParams = useSearchParams();
  const currentRoute = usePathname();
  const router = useRouter();

  const getParam = (param, defaultValue = "") =>
    searchParams.get(param) || defaultValue;

  const limit = Number(getParam("limit", 20));
  const page = Number(getParam("page", 1));
  const sortField = getParam("sortField");
  const sortOrder = getParam("sortOrder");
  const filterBy = getParam("filterBy");
  const filterValue = getParam("filterValue");
  const search = getParam("search");
  const brandIds = getParam("brandIds");
  const type = getParam("type");
  const id = getParam("id");
  const minPrice = getParam("minPrice");
  const maxPrice = getParam("maxPrice");
  const onDisplay = getParam("onDisplay");
  const deliveryDate = getParam("deliveryDate");
  const zipCode = getParam("zipCode");
  const isAvailabilty = getParam("isAvailabilty");
  const isLuxury = getParam("isLuxury");
  const inStore = getParam("inStore");
  const fieldIds = getParam("fieldIds");
  const fieldValueIds = getParam("fieldValueIds");
  const filterSubCategoryId = getParam("filterSubCategoryId");
  const keyword = getParam("keyword");
  const sort = getParam("sort");
  const order = getParam("order");
  const categoryIds = getParam("categoryIds");
  const subCategoryIds = getParam("subCategoryIds");
  const subCategory2Ids = getParam("subCategory2Ids");
  const rebateIds = getParam("rebateIds");
  const validUntil = getParam("validUntil");
  const isExpired = getParam("isExpired");
  const h = getParam("h");
  const w = getParam("w");
  const d = getParam("d");
  const dimensions = { h, w, d };
  const onSale = getParam("onSale");
  const clearance = getParam("clearance");
  const rebateAvailable = getParam("rebateAvailable");
  const criteriaId = getParam("criteriaId");
  const storeId = getParam("storeId");
  const deliveryRouteId = getParam("deliveryRouteId");
  const height = getParam("height");
  const width = getParam("width");
  const depth = getParam("depth");
  const totalCapacity = getParam("totalCapacity");
  const iceCapacity = getParam("iceCapacity");
  const dailyIceProduction = getParam("dailyIceProduction");
  const ovenCapacity = getParam("ovenCapacity");
  const washerHeight = getParam("washerHeight");
  const washerWidth = getParam("washerWidth");
  const washerDepth = getParam("washerDepth");
  const dryerHeight = getParam("dryerHeight");
  const dryerWidth = getParam("dryerWidth");
  const dryerDepth = getParam("dryerDepth");
  const capacity = getParam("capacity");
  const setProductCategoryIds = getParam("setProductCategoryIds");

  const setQueryParams = (params) => {
    if (!params || Object.keys(params).length === 0) return;

    const newParams = new URLSearchParams(searchParams);

    // Update the parameters directly
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        newParams.set(key, value);
      } else {
        newParams.delete(key);
      }
    });
    // Replace the current route with the new query string
    router.replace(`${currentRoute}?${newParams}`, { scroll: false });
  };

  const clearAllParams = ({removeKeyword}) => {
    const updatedRoute = keyword && !removeKeyword
      ? `${currentRoute}?keyword=${keyword}`
      : currentRoute;
    router.replace(updatedRoute, undefined, { scroll: false });
  };

  return {
    limit,
    page,
    sortField,
    sortOrder,
    filterBy,
    filterValue,
    search,
    brandIds,
    type,
    id,
    minPrice,
    maxPrice,
    onDisplay,
    isAvailabilty,
    isLuxury,
    inStore,
    fieldIds,
    fieldValueIds,
    filterSubCategoryId,
    keyword,
    sort,
    order,
    categoryIds,
    subCategoryIds,
    subCategory2Ids,
    rebateIds,
    validUntil,
    isExpired,
    dimensions,
    deliveryDate,
    zipCode,
    setQueryParams,
    clearAllParams,
    onSale,
    clearance,
    rebateAvailable,
    criteriaId,
    storeId,
    deliveryRouteId,
    height,
    width,
    depth,
    totalCapacity,
    iceCapacity,
    dailyIceProduction,
    ovenCapacity,
    washerHeight,
    washerWidth,
    washerDepth,
    dryerHeight,
    dryerWidth,
    dryerDepth,
    capacity,
    setProductCategoryIds,
  };
};
